/* models/graphs/layout_provider */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var model_1 = require(62) /* ../../model */;
    var LayoutProvider = /** @class */ (function (_super) {
        tslib_1.__extends(LayoutProvider, _super);
        function LayoutProvider(attrs) {
            return _super.call(this, attrs) || this;
        }
        LayoutProvider.__name__ = "LayoutProvider";
        return LayoutProvider;
    }(model_1.Model));
    exports.LayoutProvider = LayoutProvider;
}
